function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function proxyAndBufferFunctionCalls(obj, property) {
  var concreteImpl = null;
  var buffer = [];

  var proxy = function proxy() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    buffer.push(args);
  };

  var flush = function flush(func) {
    buffer.forEach(function (args) {
      return func.apply(void 0, _toConsumableArray(args));
    });
    buffer.length = 0;
  };

  Object.defineProperty(obj, property, {
    configurable: true,
    enumerable: true,
    // Until a concrete implementation is provided, return the proxy func
    get: function get() {
      return concreteImpl || proxy;
    },
    set: function set(func) {
      concreteImpl = func; // Now that we have a concrete implementation, immediately flush all the
      // buffered calls to it

      flush(concreteImpl);
    }
  });
}

export function ensureTitan() {
  if (typeof window !== 'object') {
    return;
  }

  window.titan = window.titan || {};
  window.titan.requestConditionalAd = window.titan.requestConditionalAd || [];
  window.digitalData = window.digitalData || {};
  window.digitalData.titan = window.digitalData.titan || {};
  window.digitalData.titan.adSlots = window.digitalData.titan.adSlots || [];

  if (!window.titan.adReturnedEvent) {
    proxyAndBufferFunctionCalls(window.titan, 'adReturnedEvent');
  }
}
/**
 * Takes a collection of tuples [adId, done], and makes a batch request for all
 * adIds at once. Order is important.
 * See https://github.com/domain-group/fe-co-adspot/issues/3
 *
 * @param done {Function} Called with ({adId<string>, adReturned<boolean>, size<[width<integer>, height<integer>]>})
 */

export function requestAds(requests) {
  if (typeof window !== 'object') {
    return;
  }

  requests.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        adId = _ref2[0];

    if (window.digitalData.titan.adSlots.indexOf(adId) !== -1) {
      // eslint-disable-next-line max-len
      throw new Error("Remove ".concat(adId, " from `digitalData.titan.adSlots[]` to avoid duplicate ad requests when used with `fe-co-adspot`"));
    }
  });
  window.titan.requestConditionalAd.push(requests.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        adId = _ref4[0];

    return adId;
  }));
  requests.forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        adId = _ref6[0],
        done = _ref6[1];

    window.titan.adReturnedEvent(adId, done);
  });
}